// extracted by mini-css-extract-plugin
module.exports = {"Flag":"Flag--18NNL"};